import { isCookiesServiceEnabled } from 'portal-modules/common/utils/privacy-service-wrapper'

export const event = ({ action, category, label, value }) => {
  isCookiesServiceEnabled('google_analytics_rp') &&
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    })
}
